import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import StoreAddress from './StoreAddress';
import { getId } from '@common/utils/brandDiffsUtils';
const StoreInfoBox = (props) => {
    const { t } = useTranslation();
    const { store, className } = props;
    if (!store) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("dl", { className: classNames('store-info', className) },
        React.createElement("dt", null, t('label.address')),
        React.createElement("dd", null,
            React.createElement(StoreAddress, { store: store, hidename: true })),
        store.phone && (React.createElement(React.Fragment, null,
            React.createElement("dt", null, t('label.phone')),
            React.createElement("dd", null,
                React.createElement("a", { href: `tel:${store.phone}` }, store.phone)),
            store.hasDOSService && (React.createElement(React.Fragment, null,
                React.createElement("dt", null),
                React.createElement("dd", { className: "hasDOSService-disclaimer" }, t('storelocator.hasDOSService')))))),
        store.email && (React.createElement(React.Fragment, null,
            React.createElement("dt", null, t('label.email')),
            React.createElement("dd", null,
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: `mailto:${store.email}` }, store.email)))),
        store.storeHours && (React.createElement(React.Fragment, null,
            React.createElement("dt", null, t('label.openinghours')),
            React.createElement("dd", null, store.storeHours.map((sh) => (React.createElement("p", { key: sh.day },
                sh.day,
                React.createElement("br", null),
                sh.text)))))),
        store.hasInStoreServices && getId() === 'MO' && (React.createElement(React.Fragment, null,
            React.createElement("dt", null, t('label.availableservices')),
            React.createElement("dd", { className: "store-services" },
                store.storeServices.clickAndReserve && React.createElement("p", null, t('storelocator.clickAndReserve')),
                store.storeServices.clickFromStore && React.createElement("p", null, t('storelocator.clickFromStore')),
                store.storeServices.pickUpInStore && React.createElement("p", null, t('storelocator.pickUpInStore')),
                store.storeServices.returnInStore && React.createElement("p", null, t('storelocator.returnInStore')),
                store.storeServices.exchangeInStore && React.createElement("p", null, t('storelocator.exchangeInStore')),
                store.storeServices.distantSale && React.createElement("p", null, t('storelocator.distantSale')),
                store.storeServices.bookAnAppointment && React.createElement("p", null, t('storelocator.bookAnAppointment')),
                store.storeServices.GarmentKit && React.createElement("p", null, t('storelocator.GarmentKit')),
                store.storeServices.personalizationRoom && React.createElement("p", null, t('storelocator.personalizationRoom')),
                store.storeServices.liveBoutique && React.createElement("p", null, t('storelocator.liveBoutique')))))));
};
export default StoreInfoBox;
